import React from "react";
import * as selectStyles from "./Select.css";

/**
 * Layout wrapper for aligning trigger content (used in both variants).
 */
export function TriggerContentWrapper({
  children
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <div className={selectStyles.selectRowBetween}>
      <div className={selectStyles.selectWrapCenter}>{children}</div>
    </div>
  );
}

/**
 * Renders static or dynamic text inside the trigger.
 */
export function TriggerText({ text }: { text?: string }): React.ReactElement {
  return <span className={selectStyles.selectTriggerText}>{text}</span>;
}
